import * as React from "react";
import {
  Typography as UITypography,
  TypographyProps as UITypographyProps,
  TypographyComponent,
} from "@stemscopes/ui";

export interface TypographyProps extends Omit<
  UITypographyProps<TypographyComponent>,
  "variant"
> {
  variant?:
    | ""
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "label"
    | "s1"
    | "s2"
    | "p1"
    | "p2"
    | "c1"
    | "c2";
}

const Typography: React.FC<TypographyProps> = (props) => (
  <UITypography {...props} />
);

export default Typography;
